"use client";

import {useTheme} from "next-themes";
import {FaMoon, FaSun} from "react-icons/fa";

export default function ButtonSwitchTheme({className,}: {
    className?: string;
}) {
    const {theme, setTheme, systemTheme} = useTheme();

    const currentTheme = theme === undefined ? systemTheme : theme;

    return (
        <div className={className}>
            <button
                type="button"
                className={`text-stone-500 dark:text-stone-400 hover:bg-stone-100 dark:hover:bg-stone-700  hover:rounded-xl
      focus:outline-none focus:ring-4 focus:ring-stone-200 dark:focus:ring-stone-700 rounded-lg 
      text-sm p-2.5 inline-flex items-center mx-2`}
                onClick={() => setTheme(currentTheme === "dark" ? "light" : "dark")}
            >
                {currentTheme === "light" ? <FaMoon/> : <FaSun/>}
            </button>
        </div>
    );

}
